import _ from 'lodash';
import Profile from 'common/domain/models/profile';

export default class TeamRequestsListAssembler {

  buildListFromRequestList(requests) {
    return _.uniqBy(requests.map(this.buildFromRequest), 'userId');
  }

  buildFromRequest(request) {
    return new Profile(request.employeeId, request.name, request.email);
  }

}



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestsList.assembler.js